import React, { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { AutoSuggest } from "./AutoSuggest";
import { useState } from "react";
import "./ViewportCenteredModal.scss";
import { SuccessMessages, ErrorMessages } from "../../constants/MessageConstants";
import ValidateCustomer from "../../validation/ValidateNewCustomer";
import { CheckNull } from "../../utils/Validate";
import { useNavigate } from "react-router-dom";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import ErrorMessage from "../../components/common/ErrorMessage";
import { CreateEntry, GetList } from "../../providers/dataProvider";
import { DropDownComponent } from "../../dropdown/DropDownComponent"
import { PlaceHolder } from "../../constants/PlaceHolderConstants";
import { PhoneNumberComponent } from "../../dropdown/PhoneNumberComponent";

const defaultValues = {
  customerName: null,
  address: "",
  fax: "",
  phone: "",
  email: "",
  website: "",
  countryId: 0,
  type: 2,
  distributorId: "",
  assignedEngineerId: "",
  additionalInfo: "",
}

const modalContainer =
  typeof document !== "undefined" ? document.body : undefined;

export default function AddNewCustomerModal({
  setCustList,
  setNewAddedCustomer,
  values,
  showNewCust,
  setShowNewCust,
  countryData,
  distributorData,
  assignedEngineerData,
  customerData,
  distributorInq,
  pageName,
  disabledDistributor
}) {
  const navigate = useNavigate();
  const [customerlist, setcustomerData] = useState([]);
  const [customerErrors, setCustomerErrors] = useState({});
  const [disabledCust, setDisabledCust] = useState(false);
  const [show, setShow] = useState(false);
  const [createMsg, setCreateMsg] = useState(null);
  const [listData, setListData] = useState(null);
  const [created, setCreated] = useState(false);
  const [errorShow, setErrorShow] = useState({ show: false, errorMessage: "" });
  const [isSubmit, setIsSubmit] = useState(false);
  const [salesEnggData, setSalesEngData] = useState([]);
  const [customerValues, setCustomerValues] = useState(defaultValues);

  useEffect(() => {
    setCustomerValues(defaultValues);
    setCountry(null);
    setCustDistributor(null);

  }, [])

  useEffect(() => {
    if (distributorInq) {
      if (distributorInq?.defaultCompanyDistributor === true) {
        setSalesEngData(assignedEngineerData?.filter(item => item?.userType === 1 && (item?.isActive===true || item?.identityId ===customerValues?.assignedEngineerId)))
      } else {
        setSalesEngData(assignedEngineerData?.filter(item => item?.userCompanyId === distributorInq?.value && (item?.isActive===true || item?.identityId ===customerValues?.assignedEngineerId)))
      }
      setCustomerValues({
        ...customerValues,
        distributorId: distributorInq?.value,
        countryId: distributorData?.find(item => item.id === distributorInq?.value)?.countryId,
        phone:""
      });
    }
  }, [distributorInq, showNewCust, distributorData, assignedEngineerData])

  useEffect(() => {
    const getcustomerData = () => {
      if (customerData) {
        const list = formatcustomerData(customerData);
        setcustomerData(list);
      }
    };
    getcustomerData();
  }, [customerData]);

  const formatcustomerData = (list) => {
    var te = list?.map((data, index) => ({
      label: data?.customerName,
      value: data?.id
    }));
    return te;
  };


  const HandleCancelNewCustomer = () => {
    setShowNewCust(false);
    setCustomerValues(defaultValues);
    setCustomerErrors({});
  };

  const HandleNewCustomerChange = (e) => {
    const { name, value } = e.target;
    setCustomerValues({
      ...customerValues,
      [name]: value,
    });

    const errors = ValidateCustomer({
      ...customerValues,
      [name]: value
    });

    setCustomerErrors({
      ...customerErrors,
      [name]: errors[name]
    });
  };

  useEffect(() => {
    if (customerValues?.customerName !== null && customerValues?.customerName !== undefined) {
      const errors = ValidateCustomer({
        ...customerValues,
        customerName: customerValues?.customerName
      });

      setCustomerErrors({
        ...customerErrors,
        customerName: errors["customerName"]
      });
    }
  }, [customerValues?.customerName])

  const [country, setCountry] = useState(null);
  const [custAssigned, setCustAssigned] = useState(null);
  const [custDistributor, setCustDistributor] = useState(null);


  const HandleCountryDropDown = (selectedOption) => {
    setCountry(selectedOption);
    setCustomerValues({
      ...customerValues,
      countryId: selectedOption.value,
      phone:""
    });

    // re-run the validation check on the changed field value
    const errors = ValidateCustomer({
      ...customerValues,
      countryId: selectedOption.value
    });
    // update the formErrors state
    setCustomerErrors({
      ...customerErrors,
      country: errors["country"]
    });
  }

  const HandleDistributorDropDown = (selectedOption) => {
    setCustDistributor(selectedOption)
    setCustomerValues({
      ...customerValues,
      distributorId: selectedOption.value,
    });

    // re-run the validation check on the changed field value
    const errors = ValidateCustomer({
      ...customerValues,
      distributorId: selectedOption.value
    });
    // update the formErrors state
    setCustomerErrors({
      ...customerErrors,
      distributor: errors["distributor"]
    });
  }

  const HandleAllocatedToDropDown = (selectedOption) => {
    setCustAssigned(selectedOption);
    setCustomerValues({
      ...customerValues,
      assignedEngineerId: selectedOption.value,
    });

    // re-run the validation check on the changed field value
    const errors = ValidateCustomer({
      ...customerValues,
      assignedEngineerId: selectedOption.value
    });
    // update the formErrors state
    setCustomerErrors({
      ...customerErrors,
      engineer: errors["engineer"]
    });
  }

  useEffect(() => {
    if (CheckNull(createMsg?.message).includes("Failed")) {
      let errorsmsg = createMsg.successData;
      setErrorShow({
        show: true,
        errorMessage: errorsmsg,
      });
      setDisabledCust(false);
    }
    else if (CheckNull(createMsg?.message) == SuccessMessages?.CREATED("Customer")) {
      const dt = createMsg?.successData;
      const newItem = {
        ...dt,
        label: dt?.customerName,
        value: dt?.id,
      };
      setNewAddedCustomer(newItem);
      GetList("Customer", "customer", setListData);
      setShowNewCust(false);
      setShow(true);
      setCreated(true);
      setDisabledCust(false);
      setCustomerValues(defaultValues);
    }
  }, [createMsg]);

  const HandleNewCustomer = (event) => {
    event.preventDefault();
    setCustomerErrors(ValidateCustomer(customerValues, customerData));
    setIsSubmit(true);
  };

  useEffect(() => {
    if (Object.keys(customerErrors).length === 0 && isSubmit) {
      const newCustomer = {
        customerName: customerValues?.customerName,
        address: customerValues?.address,
        fax: customerValues?.fax,
        phone: customerValues?.phone,
        email: customerValues?.email,
        website: customerValues?.website,
        countryId: customerValues?.countryId,
        type: "2",
        distributorId: customerValues?.distributorId,
        assignedEngineerId: customerValues?.assignedEngineerId,
        additionalInfo: customerValues?.additionalInfo || "",
        statusId: 1,
        customerContact: [],
        customerDocument: [],
      };
      CreateEntry("Customer", newCustomer, setCreateMsg, SuccessMessages?.CREATED("Customer"), ErrorMessages?.CREATE_ERROR("Customer"));

      setDisabledCust(true);
      setCustomerErrors({});
    }
    setIsSubmit(false);
  }, [customerErrors]);


  const ErrorDoneClick = () => {
    setErrorShow({
      show: false,
      errorMessage: "",
    });
    setCreateMsg(null);
  };

  useEffect(() => {
    if (listData?.params == "customer" && listData?.message == "success") {
      setCustList(listData?.data?.filter(item => item?.distributorId === distributorInq?.value));
    }
  }, [listData]);

  const SuccessDoneClick = () => {
    setShow(false);
    if (created) { setShowNewCust(false); return }
  };

  return (
    <div>

      <Modal
        show={showNewCust}
        centered
        size="xl"
        className="addToCustomerNamePopModal"
        dialogClassName="viewport-centered-modal-dialog"
        container={modalContainer}
      >
        <Modal.Header>
          <h5 className="modal-title">Add new Customer</h5>
          <i className="fas fa-times" onClick={HandleCancelNewCustomer}></i>
        </Modal.Header>
        <Modal.Body>
          <div className="row mt-3">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>
                  Customer Name <span className="mandatory">*</span>
                </label>
                <AutoSuggest
                  options={customerlist}
                  setStateValue={setCustomerValues}
                  stateValue={customerValues}
                  placeholder={PlaceHolder?.CUSTOMER_NAME}
                  params="customerName" 
                  className="form-control" />
                <p className="form-error">{customerErrors?.customerName}</p>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>
                  Country <span className="mandatory">*</span>{" "}
                </label>
                <DropDownComponent
                  isDisabled={["Enquiry", "jobinhand", "project"].includes(pageName) ? true : false}
                  pageName="customerPopup"
                  placeHolder={PlaceHolder?.SELECT_COUNTRY}
                  dpDownName="country"
                  stateData={countryData}
                  controlName="Country"
                  handleChange={HandleCountryDropDown}
                  value={country}
                  valueId={customerValues?.countryId}
                  setState={setCountry} />
                <p className="form-error">{customerErrors?.country}</p>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>Fax Number</label>
                <input className='form-control' name="fax" type="text" value={customerValues?.fax} placeholder={PlaceHolder?.FAX} onChange={HandleNewCustomerChange}></input>
                <p className="form-error">{customerErrors?.fax}</p>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>WebSite </label>
                <input className='form-control' name="website" type="text" value={customerValues?.website} placeholder={PlaceHolder?.WEB_SITE} onChange={HandleNewCustomerChange}></input>
                <p className="form-error">{customerErrors?.website}</p>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
              <div className="row">
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                  <div>
                    <label>Phone Number <span className="mandatory">*</span></label>
                    <PhoneNumberComponent defaultCountry={country?.code} errors={customerErrors} setValues={setCustomerValues} setErrors={setCustomerErrors} filedName="phone" values={customerValues} />
                    <p className="form-error">{customerErrors?.phone}</p>
                  </div>
                </div>
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                  <div>
                    <label>Email Address <span className="mandatory">*</span></label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder={PlaceHolder?.EMAIL_ADDRESS}
                      name="email"
                      onChange={HandleNewCustomerChange}
                      value={customerValues?.email}></input>
                    <p className="form-error">{customerErrors?.email}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>Customer Address <span className="mandatory">*</span></label>
                <textarea
                  className="form-control customer-address-textarea"
                  placeholder={PlaceHolder?.ADDRESS}
                  rows="5"
                  name="address"
                  onChange={HandleNewCustomerChange}
                  value={customerValues?.address}></textarea>
                <p className="form-error">{customerErrors?.address}</p>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2'">
              <div>
                <label>Distributor <span className="mandatory">*</span> </label>
                <DropDownComponent
                  isDisabled={disabledDistributor}
                  pageName="customerPopup"
                  dpDownName="distributor"
                  stateData={distributorData}
                  controlName="Distributor"
                  handleChange={HandleDistributorDropDown}
                  value={custDistributor}
                  valueId={customerValues?.distributorId}
                  setState={setCustDistributor}
                  placeHolder={PlaceHolder?.SELECT_DISTRIBUTOR} />
                <p className="form-error">{customerErrors?.distributor}</p>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
              <div>
                <label> Allocated To <span className="mandatory">*</span> </label>
                <DropDownComponent
                  pageName="customerPopup"
                  placeHolder={PlaceHolder?.SELECT_ALLOCATED_TO}
                  dpDownName="allocatedTo"
                  stateData={salesEnggData}
                  controlName="Allocated To"
                  handleChange={HandleAllocatedToDropDown}
                  value={custAssigned}
                  valueId={customerValues?.assignedEngineerId}
                  setState={setCustAssigned} />

                <p className="form-error">{customerErrors?.engineer}</p>
              </div>
            </div>
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>Additional Info</label>
                <textarea
                  className="form-control additional-info-textarea"
                  placeholder={PlaceHolder?.ADDITIONAL_NOTES}
                  rows="5"
                  name="additionalInfo"
                  onChange={HandleNewCustomerChange}
                  value={customerValues?.additionalInfo}></textarea>
                <p className="form-error">{customerErrors?.additionalInfo}</p>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn cancel-btn" onClick={HandleCancelNewCustomer}> Cancel </button>
          <button type="button" className={`${disabledCust ? "disable-savebtn" : ""} btn continue-btn`}
            onClick={HandleNewCustomer} disabled={disabledCust}>  Continue </button>
        </Modal.Footer>
      </Modal>

      <SaveSuccessModel createMsg={createMsg} setCreateMsg={setCreateMsg} setShow={setShow} show={show} SuccessDoneClick={SuccessDoneClick} />
      <ErrorMessage Show={errorShow?.show} errorMessage={errorShow?.errorMessage} ErrorDoneClick={ErrorDoneClick} />
    </div>
  );
}

